<!--  -->
<template>
  <div class="cold-humidity">
    <div id="diffStoragePowerChartt" style="height: 100%; width: 100%"></div>
  </div>
</template>

<script>
import charts from "echarts";
import API from "../api/index";
export default {
  data() {
    return {
      diffStoragePowerChartt: null,
      diffStoragePowerCharttOption: {},
      xAxisData: [],
      listData: [],
      listKeysList: [],
      listKeys: {},
    };
  },

  components: {},

  // computed() {},

  mounted() {
    var self = this;

    self.diffStoragePowerChartt = charts.init(
      document.getElementById("diffStoragePowerChartt")
    );
    self.queryData().then((res) => {
      self.initChart();
    });
  },

  methods: {
    queryData() {
      // this.xData = [];
      // this.yData = [];
      return new Promise((resolve, reject) => {
        this.$fetch(API.energy.queryEnergyRecordByArea).then((res) => {
          if (res.success) {
            this.listKeysList = Object.keys(res.returnObj);
            res.returnObj[this.listKeysList[0]].forEach((item) => {
              this.xAxisData.push(item.date);
            });
            // this.listData = res.returnObj;
            // res.returnObj.forEach((item, index) => {
            //   this.listKeysList = [];
            //   this.xAxisData.push(item.hours);
            //   // this.listKeysList = Object.keys(item.dataMap);
            //   if (index == 0) {
            //     for (let key in item.dataMap) {
            //       // this.listKeysList.push(key);
            //       // this.listKeys[key] = [];
            //       this.listData.push({
            //         name: key,
            //         list: [],
            //       });
            //       // this.listKeys[key].push(item.dataMap[key]);
            //       // this.listData.push({
            //       //   name: key,
            //       //   list: ,
            //       // });
            //     }
            //   }
            // });
            for (let key in res.returnObj) {
              let list = [];
              list = res.returnObj[key].map((el) => {
                return el.energyValue;
              });
              this.listData.push({
                name: key,
                list,
              });
            }
            resolve(this.listData);
            // console.log(this.listKeys, this.listData, ">>>> this.listKeys");

            // this.coldData = res.returnObj;
            // for (let key in this.coldData) {
            //   this.xData.push(key);
            //   this.yData.push(this.coldData[key]);
            // }
            // resolve(this.coldData);
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    initChart() {
      const color = [
        "#6495ED",
        "#FF6969",
        "#9BD342",
        "#FFDA00",
        "#AB4CD3",
        "#FB4CD3",
        "#FF1493",
        "#00BFFF",
        "#2E8B57",
        "#D2691E"
      ];
      // const xAxisData = [
      //   "0:00",
      //   "4:00",
      //   "8:00",
      //   "12:00",
      //   "16:00",
      //   "20:00",
      //   "24:00",
      // ];
      const yAxisData1 = [30, 35, 32, 30, 20, 45, 25];
      const yAxisData2 = [35, 30, 35, 30, 30, 48, 30];
      const yAxisData3 = [32, 41, 34, 35, 35, 46, 47];
      const yAxisData4 = [41, 32, 32, 45, 45, 45, 46];
      const yAxisData5 = [45, 45, 32, 34, 46, 42, 44];
      const yAxisData6 = [34, 35, 46, 35, 47, 46, 47];

      const listData = [
        { name: "一号", list: yAxisData1 },
        { name: "二号", list: yAxisData2 },
        { name: "三号", list: yAxisData3 },
        { name: "四号", list: yAxisData4 },
        { name: "五号", list: yAxisData5 },
        { name: "六号", list: yAxisData6 },
      ];
      const yDatas = [];
      // for (let key in this.listKeys) {
      //   yDatas.push({
      //     name: key,
      //     type: "line",
      //     lineStyle: {
      //       normal: {
      //         color: color[index],
      //         width: 2,
      //       },
      //     },
      //     //   itemStyle: {
      //     //     normal: {
      //     //       label: {
      //     //         show: true,
      //     //         position: "top",
      //     //         textStyle: {
      //     //           color: "#C23531",
      //     //           fontSize: 12,
      //     //         },
      //     //       },
      //     //     },
      //     //   },
      //     data: this.listKeys[key],
      //   });
      // }
      this.listData.forEach((item, index) => {
        yDatas.push({
          name: item.name,
          type: "line",
          lineStyle: {
            normal: {
              color: color[index],
              width: 2,
            },
          },
          //   itemStyle: {
          //     normal: {
          //       label: {
          //         show: true,
          //         position: "top",
          //         textStyle: {
          //           color: "#C23531",
          //           fontSize: 12,
          //         },
          //       },
          //     },
          //   },
          data: this.listData[index].list,
        });
      });
      //   {
      //     name: "入园",
      //     type: "line",
      //     showSymbol: false,
      //     lineStyle: {
      //       normal: {
      //         color: color[0],
      //         width: 2,
      //       },
      //     },
      //     data: yAxisData1,
      //   },

      const option = {
        color: color,
        legend: {
          icon: "rect",
          itemHeight: 5,
          itemWidth: 5,
          textStyle: {
            color: "#ffffff",
            fontSize: 11
          },
          left: 90,
          top: 0
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: 30,
          left: 0,
          bottom: 0,
          right: 30,
          containLabel: true,
        },
        xAxis: [
          {
            name: "日",
            type: "category",
            boundaryGap: false,
            axisLabel: {
              textStyle: {
                color: "#E4F5FD",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#E4F5FD",
              },
            },
            data: this.xAxisData,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：KWH",
            axisLabel: {
              show: true,
              width: "100",
              height: 12,
              fontSize: 14,
              fontFamily: "Source Han Sans SC",
              fontWeight: 400,
              color: "#ffffff",
            },
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 12,
              fontFamily: "Source Han Sans SC",
              fontWeight: 400,
              padding: [0, 0, 0, -20]
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgb(10, 59, 119)",
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "#1E2537",
                type: "solid",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        // position: "top",
        series: yDatas,
        // series: [
        //   {
        //     name: "入园",
        //     type: "line",
        //     showSymbol: false,
        //     lineStyle: {
        //       normal: {
        //         color: color[0],
        //         width: 2,
        //       },
        //     },
        //     data: yAxisData1,
        //   },
        //   {
        //     name: "出园",
        //     type: "line",
        //     showSymbol: false,
        //     lineStyle: {
        //       normal: {
        //         color: color[1],
        //         width: 2,
        //       },
        //     },
        //     data: yAxisData2,
        //   },
        // ],
      };
      this.diffStoragePowerChartt = charts.init(
        document.getElementById("diffStoragePowerChartt")
      );
      this.diffStoragePowerChartt.setOption(option);
    },
  },
};
</script>
<style lang='scss' scoped>
.cold-humidity {
  height: 100%;
}
</style>